export default "__VITE_ASSET__TOCNptKz__"